export default __webpack_public_path__ + "static/media/arial-bold.cc0ed77a.ttf";